const KeenSlider = window.KeenSlider

const {
  setInitialised,
  addWheelControls,
  useReveal,
} = window.BAO.Carousel.plugins

class ShoppableCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.dataset.cardsPerView === '3') return

    this.initialiseCarousel()
  }

  initialiseCarousel () {
    if (!this.els.slides.element || !this.els.slide.elements) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.elements,
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1.5,
          spacing: 2,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 3.5,
              spacing: 2,
            },
          },
        },
      },
      [
        setInitialised(),
        addWheelControls('horizontal'),
        useReveal(this.els?.slide?.elements),
      ],
    )
  }
}

if (!customElements.get('shoppable-carousel')) {
  customElements.define('shoppable-carousel', ShoppableCarousel)
}
